export default __webpack_public_path__ + "static/media/weightlosswithfamily_1@3x.8201c4d5.jpg";